import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { IManagableObject } from "../system/admin-panel/IManagableObject";

export class ObjectDiagnosticsModel implements IManagableObject  {
  IsChecked = false;
  Id: number = 0;
  Name: string = "";
  Owned: boolean = true;
  UserId: number = 0;
  UserName: string = "";
  Status: number = 0;
  DeviceModel: string = "";

  Phone: string = "";
  IMEI: string = "";

  PayedTill = 0;
  Time = 0;

  LastFuel = "";
  LastPower = "";
  LowPower = false;
  Online = false;
  Lat = 0;
  Lng = 0;
  Sat = 0;
  Accuracy = 0;
  Odometer = 0;
  EngineTime = 0;

  init(data?: any): void {
    if (data) {
      this.Id = data["objectId"];
      this.Name = data["objectName"];
      this.UserId = data["userId"];
      this.UserName = data["userName"];
      this.Owned = data["owned"];
      this.Status = data["status"];
      this.DeviceModel = data["deviceModel"];
      this.PayedTill = data["payedTill"];
      this.Time = data["time"];

      this.Phone = data["phone"];
      this.IMEI = data["imei"];

      this.LastFuel = data["lastFuel"];
      this.LastPower = data["lastPower"];
      this.LowPower = data["lowPower"];
      this.Online = data["online"];
      this.Lat = data["lat"];
      this.Lng = data["lng"];
      this.Sat = data["sat"];
      this.Accuracy = data["accuracy"];
      this.Odometer = data["odometer"];
      this.EngineTime = data["engineTime"];
    }
  }

  static fromJS(data: any): ObjectDiagnosticsModel {
    let result = new ObjectDiagnosticsModel();
    result.init(data);
    return result;
  }
}




@Injectable()
export class DiagnosticsService {

  constructor(private client:HttpClient) {

  }

  public GetReport(users) {
    return this.client.post("/ctrl/diagnostics", users).pipe(map((values:Array<any>) => {
      const result = [];
        for (const item of values)
          result.push(ObjectDiagnosticsModel.fromJS(item))
      return result;
    }))
  }
}
